<template>
  <div class="px-3">
    <router-link
      class="lecture-list--lecture py-2 w-100 d-flex"
      active-class="active"
      tag="div"
      :to="{
        name: 'lecture',
        params: { course: $route.params.course, lecture: lecture.id },
      }"
    >
      <div
        @click.stop.prevent="toggleCompleted(lecture, $event)"
        class="small"
        v-if="isAuthenticated"
      >
        <input type="checkbox" :checked="isCompleted" class="mx-2" style="accent-color: #212529;" />
      </div>
      <div class="" v-else>
        <i class="far fa-square text-muted px-2"></i>
      </div>
      <div class="pe-4 w-100">
        <div class="d-flex justify-content-between">
          <div class="small" :class="{ completed: isCompleted }">
            <i v-if="isStarred" class="fas fa-star text-warning"></i>
            {{ lecture.title }}
          </div>
          <div
            v-if="lecture.is_free"
            class="small fw-bold text-uppercase text-success"
          >
            <small>Free</small>
          </div>
        </div>
        <div class="small" v-if="lecture.duration">
          <small>
            <i class="far fa-clock"></i>
            {{ duration(lecture.duration) }}
          </small>
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
import _ from 'lodash'
import { duration } from '~/player/helpers.js'

export default {
  props: ['lecture'],
  computed: {
    completed() {
      return this.$store.state.completed
    },
    starred() {
      return this.$store.state.starred
    },
    isStarred() {
      return _.some(this.starred, { lecture_id: this.lecture.id })
    },
    isCompleted() {
      return _.some(this.completed, { lecture_id: this.lecture.id }) 
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated
    },
  },
  methods: {
    duration(minutes) {
      return duration(minutes)
    },
    toggleCompleted(lecture, $event) {
      this.$api
        .completeLecture(lecture.id, { is_completed: !this.isCompleted })
        .then((response) => {
          this.$store.commit('completeLecture', response.data)
        })
        .catch((error) => {
          if (error.response && error.response.status === 401) {
            iziToast.info({
              title: this.$t('Log in'),
              message: this.$t('Log in to set progress'),
            })
          } else if (error.response && error.response.status === 419) {
            iziToast.info({
              title: this.$t('Log in'),
              message: this.$t('Session expired'),
            })
          } else {
            console.error(error)
            iziToast.error({
              title: 'Error',
              message: this.$t('Something went wrong'),
              position: 'bottomLeft',
            })
          }
        })
    },
  },
}
</script>